import { StyleSheet } from 'aphrodite';
import { destructive, success } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	action: {
		color: '#929292',
		fontSize: 11,
		letterSpacing: '0.9px',
		lineHeight: '14px',
		position: 'relative',
		textTransform: 'uppercase',
	},
	cancelButton: {
		fontSize: 14,
		marginTop: 6,
	},
	container: {
		alignItems: 'flex-start',
		display: 'flex',
		textAlign: 'center',
		flexWrap: 'wrap',
		lineHeight: 1.2,
	},
	count: {
		color: success,
		fontSize: 22,
		lineHeight: '26px',
		textTransform: 'uppercase',
	},
	countFailed: {
		color: destructive,
	},
	countPercentages: {
		paddingTop: 15,
	},
	popOver: {},
	popOverContent: {
		color: '#000',
		fontSize: 11,
		padding: '0 16px',
	},
	popOverContentContainer: {
		borderRadius: '3px !important',
		transform: 'translateX(-48%)',
	},
	questionMarkIcon: {
		marginLeft: 5,
		position: 'absolute',
		right: -18,
		top: '50%',
		transform: 'translateY(-50%)',
	},
});
